import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { EntityModel } from '@data-layer/models/entities';

@Component({
  selector: 'app-marine-insurance-beneficiary-view-data',
  templateUrl: './marine-insurance-beneficiary-view-data.component.html',
  styleUrls: ['./marine-insurance-beneficiary-view-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MarineInsuranceBeneficiaryViewDataComponent {
  @Input() public beneficiary: EntityModel;
  @Input() public isShowPhone: boolean = true;
  @Input() public isShowEmail: boolean = true;
  @Input() public isShowOnlyAddress: boolean;
}
